import React, { Component } from 'react';
import _ from 'lodash';
import TextInput from '../../../../../components/ZUILib/TextInput';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import InputButton from '../../../../../components/ZUILib/InputButton';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import commonUtil from '../../../../../utils/commonUtil';
import * as typeActions from '../../actions';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const { getEwalletInfo } = typeActions;
export default class Monedero extends Component {
  constructor(props) {
    super(props);
    // this.walletNumber = "";
    // this.walletAmount = "";

    // walletNumber_mmdr
    // walletAmount_mmdr

    // walletAmount_mew

    // walletAmount_mltpc
    // walletNumber_mltpc
    // beneficiaryName_mltpc

    // walletNumber_mltpc_new
    // beneficiaryName_mltpc_new


    this.state = {
      transferenceData: this.props.transferenceData.transferenceOptions,
      // transferenceData: transferenceDataRes,

      selectedDropdownAvailableWalletsInfoValue: null,
      selectedDropdownAvailableWalletsInfoText: '',

      selectedRadioSavedWalletsInfoValue: '',

      walletNumber_mmdr: '',
      walletAmount_mmdr: '',

      walletAmount_mew: '',

      walletAmount_mltpc: '',
      walletNumber_mltpc: '',
      beneficiaryName_mltpc: '',

      walletNumber_mltpc_new: '',
      beneficiaryName_mltpc_new: '',


      isUserHasWallet: false,
      isMonederoDetails: false,
      isCardNumberVisible: false,
      isBeneficiaryNameVisible: false,

      isMonederoMesadeRegalos: false,
      isMonederoElectronico: false,
      isMonederoLiverpool_TarjetaPremiumCard: false,
      isMonederoLiverpool_TarjetaPremiumCard_New: false,
      isMonederoDigitalWallet: false,

      isNuevaCuentaDisabled: false,
      walletStatus: false,
      eWalletNumber: '',
      walleterrorMessage: '',
      walletTotalAmount: '',
    };
  }

  UNSAFE_componentWillMount() {
    const walletAmount = +this.state.transferenceData.transferableAmount + +this.state.transferenceData.bonusAmount;
    this.setState({ walletTotalAmount: walletAmount });
    if (this.state.transferenceData.savedWalletsInfo && this.state.transferenceData.savedWalletsInfo.length > 0) {
      // this.setState({ isUserHasWallet: true });
    } else {
      // this.setState({ isUserHasWallet: false });
    }
    this.bonusToolTipMessage = commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.bonusStatement');
  }
  getEwalletInformation = () => {
    if (!this.state.walletStatus) {
      const profileId = this.props.user && this.props.user.loaded && this.props.user.data.result && this.props.user.data.result.profileId ? this.props.user.data.result.profileId : '';
      getEwalletInfo(profileId).then((response) => {
        if (response.body.status.status !== 'failure') {
          this.setState({ walletStatus: true, eWalletNumber: response.body.eWalletAccountNum });
        } else {
          this.setState({ walleterrorMessage: response.body.status.errorMessage });
        }
      });
    }
  }

  onMonederoClearState = () => {
    this.setState({
      walletNumber_mmdr: '',
      walletAmount_mmdr: '',

      walletAmount_mew: '',

      walletAmount_mltpc: '',
      walletNumber_mltpc: '',
      beneficiaryName_mltpc: '',

      walletNumber_mltpc_new: '',
      beneficiaryName_mltpc_new: '',
    });
    this.props.disableContinueButton(true);
  }
  checkUpdateBeneficiaryName = (e) => {
    if (e) {
      const prevVal = this.state[e.target.name];
      const regEx = new RegExp('^[a-zA-Z ]*$');
      if (regEx.test(e.target.value)) {
        this.state[e.target.name] = e.target.value;
        this.setState({ [e.target.name]: e.target.value });
      } else {
        this.state[e.target.name] = prevVal;
        this.setState({ [e.target.name]: prevVal });
      }
    }
  }

  checkUpdateWalletNumber = (e) => {
    if (e) {
      /* eslint-disable */
      const prevVal = this.state[e.target.name];
      const regEx = new RegExp('^[0-9]*$');
      if (e.target.name === 'walletNumber_mmdr') {
        if (regEx.test(e.target.value) && e.target.value.length <= 13) {
          this.state[e.target.name] = e.target.value;
          this.setState({ [e.target.name]: e.target.value });
        } else {
          this.state[e.target.name] = prevVal;
          this.setState({ [e.target.name]: prevVal });
        }
      } else {
        if (regEx.test(e.target.value) && e.target.value.length <= 16) {
          this.state[e.target.name] = e.target.value;
          this.setState({ [e.target.name]: e.target.value });
        } else {
          this.state[e.target.name] = prevVal;
          this.setState({ [e.target.name]: prevVal });
        }
      }
    }
    /* eslint-enable */
  }
  onMonederoInfoSelectChange = (data, e) => {
    this.onMonederoClearState();
    const selectedText = e.target.options[e.target.selectedIndex].text.toLowerCase();
    this.setState({ selectedDropdownAvailableWalletsInfoValue: e.target.value, selectedDropdownAvailableWalletsInfoText: selectedText });
    if (selectedText.indexOf('monedero mesa de regalos') > -1) {
      this.setState({ isMonederoDigitalWallet: false, isMonederoMesadeRegalos: true, isMonederoElectronico: false, isMonederoLiverpool_TarjetaPremiumCard: false });
    } else if (selectedText.indexOf('monedero electronico (e-wallet)') > -1) {
      this.getEwalletInformation();
      this.props.disableContinueButton(false);
      this.setState({ isMonederoDigitalWallet: false, isMonederoMesadeRegalos: false, isMonederoElectronico: true, isMonederoLiverpool_TarjetaPremiumCard: false });
    } else if (selectedText.indexOf('monedero liverpool premium card') > -1 || selectedText.indexOf('monedero tarjeta liverpool') > -1) {
      this.setState({ isMonederoDigitalWallet: false, isMonederoMesadeRegalos: false, isMonederoElectronico: false, isMonederoLiverpool_TarjetaPremiumCard: true });
    } else if (selectedText.indexOf('monedero digital') > -1) {
      this.props.disableContinueButton(false);
      this.setState({ isMonederoDigitalWallet: true, isMonederoMesadeRegalos: false, isMonederoElectronico: false, isMonederoLiverpool_TarjetaPremiumCard: false });
    }

    this.setState({ selectedRadioSavedWalletsInfoValue: '' });
  }
  onWalletAmountNumberChange = (e) => {
    /* eslint-disable */
    this.checkUpdateWalletNumber(e);
    if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero mesa de regalos') > -1) {
      if (this.state.walletNumber_mmdr.length > 0) {
        this.props.disableContinueButton(false);
      } else {
        this.props.disableContinueButton(true);
      }
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero digital') > -1) {
      this.props.disableContinueButton(false);
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero electronico (e-wallet)') > -1) {
      this.props.disableContinueButton(false);
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero liverpool premium card') > -1 || this.state.selectedDropdownAvailableWalletsInfoTextselectedText.indexOf('monedero tarjeta liverpool') > -1) {
      if (this.state.isUserHasWallet) {
        if (this.state.selectedRadioSavedWalletsInfoValue === '') {
          if (this.state.walletNumber_mltpc_new && this.state.walletNumber_mltpc_new.length > 0 && this.state.beneficiaryName_mltpc_new && this.state.beneficiaryName_mltpc_new.length > 0) {
            this.props.disableContinueButton(false);
          } else {
            this.props.disableContinueButton(true);
          }
        } else {
          if (this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc < +this.state.transferenceData.transferableAmount) {
            this.props.disableContinueButton(false);
          } else {
            this.props.disableContinueButton(true);
          }
        }
      } else {
        if (this.state.walletNumber_mltpc.length > 0 && this.state.beneficiaryName_mltpc.length > 0) {
          this.props.disableContinueButton(false);
        } else {
          this.props.disableContinueButton(true);
        }
      }
    }
    /* eslint-enable */
  }

  onBeneficiaryNameNewChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    this.state[e.target.name] = e.target.value;
    if (this.state.walletNumber_mltpc_new && this.state.walletNumber_mltpc_new.length > 0 && this.state.beneficiaryName_mltpc_new && this.state.beneficiaryName_mltpc_new.length > 0) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }
  onExceptionKeysCheck = (e) => {
    if (e.which === 46 || e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45) {
      e.preventDefault();
    }
  }

  onBeneficiaryNameChange = (e) => {
    this.checkUpdateBeneficiaryName(e);
    if (this.state.walletNumber_mltpc && this.state.walletNumber_mltpc.length > 0 && this.state.beneficiaryName_mltpc && this.state.beneficiaryName_mltpc.length > 0) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  handleRadioSelected = (data, e) => {
    this.setState({ selectedRadioSavedWalletsInfoValue: e.target.value });
    if (this.state.walletAmount_mltpc.length > 0 &&
      (this.state.walletAmount_mltpc.length > 0 && +this.state.walletAmount_mltpc < +this.state.transferenceData.transferableAmount)) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  onNuevaCuentaClick = () => {
    this.setState({ selectedRadioSavedWalletsInfoValue: '' });
    this.setState({ isNuevaCuentaDisabled: true, isMonederoLiverpool_TarjetaPremiumCard_New: true });
    this.props.disableContinueButton(true);
  }

  onUserDoesNotHasWalletFormClick = () => {
    this.setState({ selectedRadioSavedWalletsInfoValue: '' });
  }

  getFormData = () => {
    let reqParams = {};
    if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero mesa de regalos') > -1) {
      reqParams = {
        walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
        walletNumber: this.state.walletNumber_mmdr,
        walletOrEmployeeCardAmount: this.state.transferenceData.transferableAmount,
        bonusAmount: this.state.transferenceData.bonusAmount,
        bonusPercentage: this.state.transferenceData.bonusPercentage,
      };
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero digital') > -1) {
      reqParams = {
        walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
        walletNumber: this.props.user.data.result.digitalWalletAccNumber ? this.props.user.data.result.digitalWalletAccNumber : '',
        walletOrEmployeeCardAmount: this.state.transferenceData.transferableAmount,
        bonusAmount: this.state.transferenceData.bonusAmount,
        bonusPercentage: this.state.transferenceData.bonusPercentage,
      };
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero electronico (e-wallet)') > -1) {
      reqParams = {
        walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
        walletNumber: this.state.eWalletNumber ? this.state.eWalletNumber : '',
        walletOrEmployeeCardAmount: this.state.transferenceData.transferableAmount,
        bonusAmount: this.state.transferenceData.bonusAmount,
        bonusPercentage: this.state.transferenceData.bonusPercentage,
      };
    } else if (this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero liverpool premium card') > -1
      || this.state.selectedDropdownAvailableWalletsInfoText.indexOf('monedero tarjeta liverpool') > -1) {
      if (this.state.selectedRadioSavedWalletsInfoValue === '') {
        reqParams = {
          walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
          walletNumber: this.state.walletNumber_mltpc,
          walletHolderName: this.state.beneficiaryName_mltpc,
          walletOrEmployeeCardAmount: this.state.transferenceData.transferableAmount,
          bonusAmount: this.state.transferenceData.bonusAmount,
          bonusPercentage: this.state.transferenceData.bonusPercentage,
        };
      } else {
        reqParams = {
          walletType: _.find(this.state.transferenceData.availableWalletsInfo, { accountName: this.state.selectedDropdownAvailableWalletsInfoValue }).accountName,
          walletOrEmployeeCardAmount: this.state.transferenceData.transferableAmount,
          accountNumber: _.find(this.state.transferenceData.savedWalletsInfo, { accountId: this.state.selectedRadioSavedWalletsInfoValue }).accountNumber,
          walletOrEmployeeIdentifierId: _.find(this.state.transferenceData.savedWalletsInfo, { accountId: this.state.selectedRadioSavedWalletsInfoValue }).accountId,
          bonusAmount: this.state.transferenceData.bonusAmount,
          bonusPercentage: this.state.transferenceData.bonusPercentage,
        };
      }
    }
    return reqParams;
  }

  render() {
    const webRow = 'col-xs-4';
    const wapRow = 'col-xs-12';

    const webBonusLbl = {
      fontSize: '16px',
      color: '#333333',
    };

    const digitWAP = {
      marginTop: '-18px',
      marginBottom: '30px',
      color: '#333333',
      fontWeight: 500,
      fontSize: '12px',
    };

    const partialWebLbl = {
      color: '#333333',
      fontSize: '16px',
      fontWeight: 500,
    };

    const nuevaCuentaButtonJson = {
      name: 'Nueva cuenta / tarjeta',
      type: 'button',
      autoFocus: false,
      classname: 'btnSecondarySpecial size-Medium',
      value: 'Nueva cuenta / tarjeta',
      onClickHandler: this.onNuevaCuentaClick,
      disabled: this.state.isNuevaCuentaDisabled,
    };
    const availableWalletsInfo = {
      id: 'availableWalletsInfo',
      optionCaption: 'Selecciona el banco de destino',
      optionText: 'labelResourceId',
      optionValue: 'value',
      options: [],
    };

    const displayFlexWeb = {
      display: 'flex',
      marginBottom: '0',
      alignItems: 'center',
    };

    /* eslint-disable */
    // this.state.transferenceData.availableWalletsInfo.map((wallet) => {
    //   availableWalletsInfo.options.push({
    //     value: wallet.accountId,
    //     labelResourceId: wallet.accountName,
    //   });
    // });
    this.state.transferenceData.availableWalletsInfo.map((wallet) => {
      availableWalletsInfo.options.push({
        value: wallet.accountName,
        labelResourceId: +wallet.commissionFee !== 0 ? wallet.accountName + ' ' + '(' + wallet.commissionFee + '%' + ' ' + 'comisión' + ')' :
          wallet.accountName + ' ' + '(' + 'Sin' + ' ' + 'comisión' + ')',
      });
    });
    /* eslint-enable */

    const savedWalletsInfo = {
      name: 'savedWalletsInfo',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.savedWalletsInfo) {
      this.state.transferenceData.savedWalletsInfo.map(wallet =>
        savedWalletsInfo.options.push({
          id: 'radio_' + wallet.accountId,
          value: wallet.accountId,
          displayName: <span>{wallet.accountType}</span>,
          subDetailsHTML: <p>{wallet.accountNumber}</p>,
          selected: false,
        }),
      );
    }

    const userHasWallet = (
      <div>
        <div className="row">
          <div className={channel === constChannels.WEB ? webRow : wapRow}>
            <form className="margin20">
              <span className="titleForm">Selecciona monedero</span>
              <div>
                {savedWalletsInfo.options.map((option, index) => (
                  <div className="radio_group" key={index}>
                    <RadioButton
                      checked={this.state.selectedRadioSavedWalletsInfoValue === option.value}
                      displayName={option.displayName}
                      id={option.id}
                      value={option.value}
                      name="savedWalletsInfo"
                      radioCssClass={'radio selectCard'}
                      subDetailsHTML={option.subDetailsHTML}
                      onChangeFunction={this.handleRadioSelected}
                    />
                  </div>
                ))}
              </div>
            </form>
          </div>
          <div className="col-md-8 col-sm-8 addNewCard">
            <InputButton buttonAttr={nuevaCuentaButtonJson} />
          </div>
        </div>
        <div className="row">
          {this.state.isMonederoLiverpool_TarjetaPremiumCard_New ?
            <div onClick={this.onUserDoesNotHasWalletFormClick}>
              <div className="col-xs-12">
                <div className="row">
                  <div className={channel === constChannels.WEB ? webRow : wapRow}>
                    <div className="formBlock">
                      <TextInput
                        parentClassName="materialStyle input-group error"
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        star="*"
                        onChange={this.onWalletAmountNumberChange}
                        name="walletNumber_mltpc_new"
                        inputValue={this.state.walletNumber_mltpc_new}
                        label="Número de Monedero"
                        required
                        maxlength="16"
                        ref={txt => this.walletNumber_mltpc_new = txt}
                      />
                      <p
                        className="quantityBlockLabel"
                        style={{
                          marginTop: '-18px',
                          marginBottom: '30px',
                          color: '#333333',
                        }}
                      >
                        El número de digitos del monedero debe ser 13 o 16
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12">
                <div className="row">
                  <div className={channel === constChannels.WEB ? webRow : wapRow}>
                    <div className="formBlock">
                      <TextInput
                        parentClassName="materialStyle input-group error"
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        star="*"
                        maxlength="100"
                        required
                        onChange={this.onBeneficiaryNameNewChange}
                        name="beneficiaryName_mltpc_new"
                        inputValue={this.state.beneficiaryName_mltpc_new}
                        label="Nombre del beneficiario"
                        ref={txt => this.beneficiaryName_mltpc_new = txt}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : null}
        </div>
      </div>
    );

    return (
      /* eslint-disable */
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div className="contentInfo infoActive display-block">
            <div className="display-block" id="option1">
              <div className="col-xs-12" style={{ padding: 0 }}>
                <SelectionTab
                  classname="cSelect required"
                  id={availableWalletsInfo.id}
                  options={availableWalletsInfo.options}
                  optionCaption={'Selecciona monedero'}
                  optionText={'labelResourceId'}
                  optionValue={'value'}
                  handleSelectedOption={this.onMonederoInfoSelectChange}
                />
              </div>

              {this.state.isMonederoMesadeRegalos ?
                <div>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className="formBlock accountTransference">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          star="*"
                          onChange={this.onWalletAmountNumberChange}
                          onKeyPress={this.onExceptionKeysCheck}
                          name="walletNumber_mmdr"
                          maxlength="13"
                          required
                          inputValue={this.state.walletNumber_mmdr}
                          label="Número de monedero"
                          ref={txt => this.walletNumber_mmdr = txt}
                          type="number"
                        />
                        <p 
                          className="quantityBlockLabel"
                          style={digitWAP}
                        >
                          El número de digitos del monedero debe ser 13 o 16
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                : null}
              {this.state.isMonederoElectronico ?
                <div>
                </div>
                : null}
              {this.state.isMonederoDigitalWallet ?
                <div>
                </div>
                : null}
              {this.state.isMonederoLiverpool_TarjetaPremiumCard ?
                <div>
                  {this.state.isUserHasWallet ?
                    userHasWallet
                    : <div>
                      <div className="col-xs-12">
                        <div className="row">

                          <div className="formBlock accountTransference">
                            <TextInput
                              className="inputMaterial"
                              labelClassName="placeHolderMaterial"
                              star="*"
                              onChange={this.onWalletAmountNumberChange}
                              onKeyPress={this.onExceptionKeysCheck}
                              name="walletNumber_mltpc"
                              maxlength="16"
                              inputValue={this.state.walletNumber_mltpc}
                              label="Número de Monedero"
                              required
                              ref={txt => this.walletNumber_mltpc = txt}
                              type="number"
                            />
                            <p 
                              className="quantityBlockLabel"
                              style={digitWAP}
                            >
                              El número de digitos del monedero debe ser 13 o 16
                            </p>
                          </div>

                        </div>
                      </div>
                      <div className="col-xs-12">
                        <div className="row">
                          <div className="formBlock">
                            <TextInput
                              className="inputMaterial"
                              labelClassName="placeHolderMaterial"
                              star="*"
                              onChange={this.onBeneficiaryNameChange}
                              maxlength="100"
                              name="beneficiaryName_mltpc"
                              inputValue={this.state.beneficiaryName_mltpc}
                              label="Nombre del beneficiario"
                              required
                              ref={txt => this.beneficiaryName_mltpc = txt}
                            />
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
                : null}
            </div>
            {!this.props.transferenceMethodTypeClosure && this.state.selectedDropdownAvailableWalletsInfoValue ?
              <div className="col-xs-12 inputsBlock display-block" style={{ padding: 0 }}>
                <p style={partialWebLbl}>Disponible para cierre&nbsp;
                  <i className="iClass icon-ayuda tooltip-container text-pink" style={{fontWeight: 'bold'}}>
                    <span className="tooltip-box dir-right">
                      {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.monedero.amount.tooltip')}</span>
                  </i>
                </p>
                <p>
                  <span className="estimatedQuant" style={{color: '#333333'}}>{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</span></p>
                <React.Fragment>
                  {+this.state.transferenceData.bonusAmount !== 0 ? <React.Fragment>
                    <p style={partialWebLbl}>Bono total &nbsp;
                    <i className="iClass icon-ayuda tooltip-container">
                        <span className="tooltip-box">
                          {+this.state.transferenceData.bonusPercentage}% {this.bonusToolTipMessage}</span>
                      </i></p>
                    <p><span className="estimatedQuant" style={{color: '#333333'}}>+ {commonUtil.getCurrency(this.state.transferenceData.bonusAmount)}</span></p>
                    <hr />
                    <p style={partialWebLbl}>Total</p>
                    <p><span className="estimatedQuant" style={{color: '#333333'}}>{commonUtil.getCurrency(+this.state.transferenceData.transferableAmount + +this.state.transferenceData.bonusAmount)}</span></p>
                  </React.Fragment> : null}
                </React.Fragment>
              </div> : null}
          </div>
          :
          <div>
            <div className="row display-block" id="option1">
              <div className={channel === constChannels.WEB ? webRow : wapRow}>
                <SelectionTab
                  classname="cSelect required"
                  id={availableWalletsInfo.id}
                  options={availableWalletsInfo.options}
                  optionCaption={'Selecciona monedero'}
                  optionText={'labelResourceId'}
                  optionValue={'value'}
                  handleSelectedOption={this.onMonederoInfoSelectChange}
                />
              </div>

              {this.state.isMonederoMesadeRegalos ?
                <div>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className={channel === constChannels.WEB ? webRow : wapRow}>
                        <div className="formBlock">
                          <TextInput
                            className="inputMaterial"
                            labelClassName="placeHolderMaterial"
                            star="*"
                            onChange={this.onWalletAmountNumberChange}
                            name="walletNumber_mmdr"
                            maxlength="13"
                            required
                            inputValue={this.state.walletNumber_mmdr}
                            label="Número de Monedero"
                            ref={txt => this.walletNumber_mmdr = txt}
                          />
                          <p 
                            className="quantityBlockLabel"
                            style={{marginTop: '-18px', marginBottom: '30px', color: '#333333'}}
                          >
                            El número de digitos del monedero debe ser 13 o 16
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                : null}
              {this.state.isMonederoElectronico ?
                <div>
                </div>
                : null}
              {this.state.isMonederoDigitalWallet ?
                <div>
                </div>
                : null}
              {this.state.isMonederoLiverpool_TarjetaPremiumCard ?
                <div>
                  {this.state.isUserHasWallet ?
                    userHasWallet
                    : <div>
                      <div className="col-xs-12">
                        <div className="row">
                          <div className={channel === constChannels.WEB ? webRow : wapRow}>
                            <div className="formBlock">
                              <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                star="*"
                                onChange={this.onWalletAmountNumberChange}
                                name="walletNumber_mltpc"
                                maxlength="16"
                                inputValue={this.state.walletNumber_mltpc}
                                label="Número de Monedero"
                                required
                                ref={txt => this.walletNumber_mltpc = txt}
                              />
                              <p 
                                className="quantityBlockLabel"
                                style={{marginTop: '-18px', marginBottom: '30px', color: '#333333'}}
                              >
                                El número de digitos del monedero debe ser 13 o 16
                            </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12">
                        <div className="row">
                          <div className={channel === constChannels.WEB ? webRow : wapRow}>
                            <div className="formBlock">
                              <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                star="*"
                                onChange={this.onBeneficiaryNameChange}
                                maxlength="100"
                                name="beneficiaryName_mltpc"
                                inputValue={this.state.beneficiaryName_mltpc}
                                label="Nombre del beneficiario"
                                required
                                ref={txt => this.beneficiaryName_mltpc = txt}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}

                </div>
                : null}
            </div>
            {!this.props.transferenceMethodTypeClosure && this.state.selectedDropdownAvailableWalletsInfoValue ? 
            <div className="row" id="option1" style={displayFlexWeb}>
              <div className="col-md-3 col-sm-3">
                <span style={webBonusLbl}>Disponible para cierre</span>
                &nbsp;<i className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                  style={{fontWeight: 'bold'}}
                >
                  <span 
                    className={`tooltip-box tooltipBox344 tooltipIcon344`}
                  >
                    <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                        Monto disponible
                    </p>
                    <p style={{padding: '0 2%'}}> 
                    {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.monedero.amount.tooltip')}
                    </p>
                  </span>
                </i>
                <div className="quantityBlock">
                  <strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong>
                </div>
              </div>
              
                {+this.state.transferenceData.bonusAmount !== 0 ?
                  <React.Fragment>
                    <div className="wrapOperator">
                      <div className="operator">+</div>
                    </div>
                    <div className="col-md-2 col-sm-2">
                    <span style={webBonusLbl}>&nbsp;Bono total</span>
                    &nbsp;<i className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                      style={{fontWeight: 'bold'}}
                    >
                      <span 
                        className={`tooltip-box tooltipBox344  tooltipIcon344`}
                      >
                        <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                            Bono
                        </p>
                        <p style={{padding: '0 2%'}}> 
                          {+this.state.transferenceData.bonusPercentage}% {this.bonusToolTipMessage}
                        </p>
                      </span>
                    </i>
{/*                       <i className="iClass icon-ayuda tooltip-container">
                        <span className="tooltip-box">
                          {+this.state.transferenceData.bonusPercentage}% {this.bonusToolTipMessage}</span>
                      </i><span><small>&nbsp;Bono total</small></span> */}
                      <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.bonusAmount)}</strong></div>
                    </div>
                    <div className="wrapOperator">
                      <div className="operator">=</div>
                    </div>
                    <div className="col-md-3 col-sm-3"><span style={webBonusLbl}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total</span>
                      <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(+this.state.transferenceData.transferableAmount + +this.state.transferenceData.bonusAmount)}</strong></div>
                    </div>
                  </React.Fragment> : null}
              
            </div> : null}
          </div>}
      </React.Fragment>
      /* eslint-enable */
    );
  }
}
